import { Link2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ShareButtonProps {
  onClick?: () => void
}

/**
 * Share-link icon used by every block's action rail. Rendered only when
 * PartsRenderer passes an `onShare` callback (i.e. the parent message has
 * been persisted). Styled as a small outline icon so it sits cleanly next
 * to the per-block download icons without overlap.
 */
export function ShareButton({ onClick }: ShareButtonProps) {
  if (!onClick) return null
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={onClick}
      className="size-7"
      title="Share this as a public link"
      aria-label="Share this result"
    >
      <Link2 className="size-3.5" />
    </Button>
  )
}
